module.exports = __webpack_public_path__ + "985f61d62fb28a4f10978e5e0f422755.png";